function rankToRole(rank: number): string {
  switch (rank) {
    case 1:
      return "Super Admin";
    case 2:
      return "Manager";
    case 3:
      return "Support";
    case 4:
      return "Organization Owner";
    case 5:
      return "Organization Manager";
    case 6:
      return "Organization Member";
    default:
      return "Unknown";
  }
}

function ranksToArrayObject(ransk: number[]) {
  return ransk.map((rank) => {
    return {
      label: rankToRole(rank),
      value: rank,
    };
  });
}

export { ranksToArrayObject };

export default rankToRole;
